type ScreenDimensionConfig = {
  maxWidth: number;
  appScreenWidthPercentage: number;
};

const ScreenDimensions: Record<string, ScreenDimensionConfig> = {
  mobileOrTablet: {
    maxWidth: 768,
    appScreenWidthPercentage: 100,
  },
  desktopSmallMedium: {
    maxWidth: 1200,
    appScreenWidthPercentage: 60,
  },
  desktopLarge: {
    maxWidth: Infinity,
    appScreenWidthPercentage: 50,
  },
};

export default ScreenDimensions;
